export enum GiftReceivedPageStep {
  INITIAL = 'initial',
  ACCEPT = 'accept',
  DECLINED = 'declined',
}
